import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";

import { Modal, Button, Form, InputGroup, FormControl, Spinner } from "react-bootstrap";
import { InfoCircle, PersonCircle, X, Send, CheckAll } from "react-bootstrap-icons";


export const OTPModal = ({ show, resend, onSubmit, onCancel, otpValid, verifyingOTP, handleResendOTP, verificationResult, verfiedRcptInfo, otpVerified }) => {

  const [ activateResend, setActivateResent ] = useState(true);
  const [ otpCode, setOtpCode ] = useState("");
  const [ validationMsg, setValidationMsg ] = useState("");
  const [ otpSent, setOtpSent ] = useState(false);
  const [ invalidOTP, setInvalidOTP ] = useState(false);

  useEffect(() => {
    if(!show){
      setOtpCode("");
      setActivateResent(true);
    }
  }, [show]);

  useEffect(() => {
    if (resend){
      setTimeout(() => {
        setActivateResent(false);
      }, 30000);
    }
  }, [resend]);

  useEffect(() => {
    if( verificationResult && Object.keys(verificationResult).length > 1 && otpSent){
      if(verificationResult.data && verificationResult.status !== 200){
        setValidationMsg(verificationResult.data);
      }
    }
  }, [verificationResult, otpSent, otpValid]);

  useEffect(() => {
    if(!otpVerified && !verifyingOTP && otpSent){
      setInvalidOTP(true);
      setOtpSent(false);
    }
  }, [otpVerified, verifyingOTP, otpSent]);

  const handleOnSubmit = () => {
    setInvalidOTP(false);
    onSubmit(otpCode);
    setOtpSent(true);
  };

  const handleResend = () => {
    handleResendOTP();
    setOtpSent(false);
    setInvalidOTP(false);
  };

  const handleOnCancel = () => {
    onCancel();
    setOtpCode("");
    setOtpSent(false);
    setOtpCode("");
    setInvalidOTP(false);
  };

  const handleChange = (e) => {
    setOtpCode(e.target.value);
    setOtpSent(false);
    setInvalidOTP(false);
    setOtpSent(false);
  };


  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <PersonCircle/> Recipient-Verification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {/* p-2 border border-light  */}
        <div className="row">
          <div className="col-9 d-flex align-items-center">
            <p> <InfoCircle/> A One-Time-Password (OTP) was sent to your mobile number. </p>
            {/* <br/>
            <p className="text-muted"> Did not receive OTP? </p> */}
          </div>
          <div className="col-3 d-flex justify-content-end">
            <Button variant="outline-info" onClick={handleResend} disabled={activateResend}> Resend OTP </Button>
          </div>
        </div>
        <br/>
        <>
          <Form.Label>Enter the OTP below:</Form.Label>
          <br/>
          <InputGroup className="mb-3">
            <FormControl 
              name="otpCode"
              placeholder="OTP Code"
              aria-label="OTP Code"
              value={otpCode}
              onChange={handleChange}
            />
            <InputGroup.Append>
              <Button variant="primary" onClick={handleOnSubmit}> 
                { verifyingOTP ? <Spinner animation="border" role="status" size="sm" /> : ( otpVerified ? <CheckAll/> : <Send/> )} {" "} Submit
              </Button>
            </InputGroup.Append>
          </InputGroup>
          { invalidOTP && <div className="text-danger"> {validationMsg} </div> }
        </>
        <hr/>
        <div>
          <Button variant="secondary" onClick={handleOnCancel}>
            <X /> {" "} Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
